/**
 * Privacy Opt-Out Manager
 * Handles GPC detection and Shopify consent API integration
 * CCPA/US State Privacy Law compliant
 *
 * Opt-out status is managed server-side via customer tags ('privacy-opted-out')
 * and Shopify Flow. This script handles browser-level signals (GPC) and
 * Shopify's customerPrivacy consent API.
 */
(() => {
  'use strict';

  const PrivacyOptOut = {
    hasGPCSignal: false,

    /**
     * Initialize the privacy opt-out manager
     */
    init() {
      this.hasGPCSignal = this.detectGPC();

      // Show GPC notice if signal detected
      this.updateGPCNotice();

      // Sync GPC signal with Shopify consent API
      if (this.hasGPCSignal) {
        this.syncWithShopifyConsent(true);
      }

      console.log('[PrivacyOptOut] Initialized', {
        hasGPCSignal: this.hasGPCSignal
      });
    },

    /**
     * Detect Global Privacy Control (GPC) signal
     * @returns {boolean}
     */
    detectGPC() {
      return navigator.globalPrivacyControl === true;
    },

    /**
     * Update GPC notice visibility on privacy page
     */
    updateGPCNotice() {
      const gpcNotice = document.getElementById('privacy-gpc-notice');
      if (gpcNotice) {
        gpcNotice.style.display = this.hasGPCSignal ? 'block' : 'none';
        gpcNotice.setAttribute('aria-hidden', this.hasGPCSignal ? 'false' : 'true');
      }
    },

    /**
     * Sync with Shopify's customerPrivacy API
     * @param {boolean} optOut - Whether to opt out
     */
    syncWithShopifyConsent(optOut, retryCount = 0) {
      const MAX_RETRIES = 5;
      const RETRY_DELAY = 500;

      if (typeof window.Shopify !== 'undefined' && window.Shopify.customerPrivacy) {
        try {
          if (typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            window.Shopify.customerPrivacy.setTrackingConsent({
              marketing: !optOut,
              analytics: !optOut,
              preferences: true,
              sale_of_data: !optOut
            }, () => {
              console.log('[PrivacyOptOut] Shopify setTrackingConsent completed:', {
                sale_of_data: !optOut,
                marketing: !optOut,
                analytics: !optOut
              });
            });
          }
        } catch (e) {
          console.error('[PrivacyOptOut] Error syncing with Shopify consent:', e);
        }
      } else if (retryCount < MAX_RETRIES) {
        setTimeout(() => {
          this.syncWithShopifyConsent(optOut, retryCount + 1);
        }, RETRY_DELAY * (retryCount + 1));
      }
    },

    /**
     * Open cookie consent modal (if available)
     */
    openCookieConsent() {
      let shown = false;

      if (typeof window.privacyBanner !== 'undefined' &&
          typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        shown = true;
      } else if (typeof window.Shopify !== 'undefined' &&
                 window.Shopify.privacyBanner &&
                 typeof window.Shopify.privacyBanner.showPreferences === 'function') {
        window.Shopify.privacyBanner.showPreferences();
        shown = true;
      } else if (typeof window.Shopify !== 'undefined' &&
                 window.Shopify.customerPrivacy &&
                 typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
        window.Shopify.customerPrivacy.showPreferences();
        shown = true;
      }

      if (!shown) {
        const cookieConsent = document.querySelector('.cookie_consent');
        if (cookieConsent) {
          cookieConsent.style.display = 'block';
          shown = true;
        }
      }

      if (!shown) {
        const container = document.getElementById('privacy-message');
        if (container) {
          container.className = 'privacy-message privacy-message--error';
          container.textContent = 'Cookie preferences panel is not available. Please check your browser cookie settings or contact us for assistance.';
          container.style.display = 'block';
        }
      }
    }
  };

  window.PrivacyOptOut = PrivacyOptOut;
})();
